module.exports = __webpack_public_path__ + "media/images/ln/num_4-f9293de1c44366f6887625e86aa08f17.png";